export const version = {
    major: 4,
    minor: 1,
    patch: 8,
};
